<mat-form-field class="w-100">
  <mat-label>{{placeholder}}</mat-label>
  <input
    matInput
    [formControl]="entityCode"
    [matAutocomplete]="entityList"
  />
  <button *ngIf="entityCode.value" type="button" mat-icon-button matSuffix>
    <mat-icon class="button-clear-filter"
      (click)="cleanEntity()"
      matTooltip="Borrar"
    >highlight_off</mat-icon>
  </button>
  <mat-autocomplete
    (optionSelected)="changeSelectEntity()"
    #entityList="matAutocomplete"
    [displayWith]="displayFnEntity"
  >
    <mat-option
      *ngFor="
        let entity of listEntitiesAutocomplet | async"
      [value]="entity"
    >
      <span> {{ entity.entityName }} </span>
    </mat-option>
  </mat-autocomplete>
</mat-form-field>
